import Vue from 'vue'
import App from './App.vue'
import router from './router'
import api from './utils/api'
import {resetForm} from "@/utils/hjx";


//引入全局常量
import constant from './const/const.js'
Vue.use(constant);

import '@/theme/normalize.less'
import '@/theme/global.less'

import '@/assets/styles/huanjixia.scss' // huanjixia css

import vueWechatTitle from 'vue-wechat-title'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'


import Components from '@/components'

import moment from 'moment'

Vue.prototype.$moment = moment
Vue.prototype.resetForm = resetForm

Vue.use(ElementUI)


Vue.config.productionTip = false
Vue.use(vueWechatTitle)



Vue.prototype.$api = api
Vue.use(Components)

Vue.prototype.$app = {
  // 初始化 $app 对象的属性
  model: {}, // 确保 model 属性存在，可根据需要进行初始化
}

//单选
Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    const ariaEls = el.querySelectorAll('.el-radio__original')
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden')
    })
  }
})







new Vue({
  router,
  render: h => h(App),
}).$mount('#app')






// 根据login接口返回动态添加路由
let isLogin = false
console.log(router.history);
if(router.history.current.name !== '/login' && router.history.current.name !== 'searchPrice' && router.history.current.name !== 'modelValuation') {
  console.log(router.history.current.name);
  let routerInterval = setInterval(() => {

    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    console.log(userInfo);
    if(userInfo) {
      clearInterval(routerInterval)
      isLogin = true
      let menus = userInfo.data.menus
      let pRouter = [{
        path: '/index',
        name: '/index',
        component: () => import('@/pages/index'),
        children: []
      }]

      let routers = []
      for(let i in menus) {

        if(menus[i].children instanceof Array && menus[i].children.length > 0) {
          for(let j in menus[i].children) {
            routers.push({
              path: `/${menus[i].children[j].url}`,
              name: `${menus[i].children[j].url}`,
              component: () => import(`@/pages${menus[i].children[j].url.split('index')[1]}`),
              meta: {
                title: menus[i].children[j].menuName,
              }
            })
          }

        } else {
          routers.push({
            path: `/${menus[i].url}`,
            name: `${menus[i].url}`,
            component: () => import(`@/pages${menus[i].url.split('index')[1]}`),
            meta: {
              title: menus[i].menuName,
            }
          })
        }
      }
      routers.push({
        path: '/index/merchant/newMerchant',
        name: '/index/merchant/newMerchant',
        component: () => import('@/pages/merchant/newMerchant'),
        meta: {
          title: '新建商户'
        }
      })
      routers.push({
        path: '/index/serviceProviderManage/walletDetail',
        name: '/index/serviceProviderManage/walletDetail',
        component: () => import('@/pages/serviceProviderManage/walletDetail'),
        meta: {
          title: '钱包明细'
        }
      })
      pRouter[0].children = routers
      router.addRoutes(pRouter);
    }
  },500)

  let loginInterval = setTimeout(() => {
    clearInterval(routerInterval)
    clearInterval(loginInterval)
    if(!isLogin) {
      router.push({path: '/login'})
      // location.href = '/login'
    }
  }, 3000)
}




// rem设置
// let initHtmlFontSize = () => {

//   let rate = 625 / 375 / 200;
//   let fs = (document.documentElement.clientWidth || document.body.clientWidth) * rate;
//   document.getElementsByTagName('html')[0].style.fontSize =  fs + '%';
// }
// initHtmlFontSize();
// window.onresize = () => {
//   initHtmlFontSize();
// }
